import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome'

class KeyboardKey extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pressed: false,
      canpress: true,
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }

  handlePress() {
    if (this.state.canpress === true) {
      this.props.handleKeyPress(this.props.keyval[this.props.virtual_keyboard_mode]);
      this.setState({
        pressed: true,
        canpress: false
      })
      this.timeout = setTimeout(() => {
        this.setState({
          pressed: false,
          canpress: true
        })
        this.timeout = null
      }, 125)

    }

  }

  render() {
    let classes = "pressin keyopacity";
    if (this.state.pressed === true) {
      classes += " active"
    }
    if (this.props.contents[this.props.virtual_keyboard_mode] === null) {
      classes += " keyhide"
      return (
        // <div style={{display: 'hidden'}}><div style={this.props.mainstyle[1]} className={classes}><span className="kspn">&nbsp;</span></div></div>
        <div style={this.props.mainstyle} className={classes}><span className="kspn-tampa">&nbsp;</span></div>
      )
    }
    classes += " phand"
    let innercontent;
    let spanClass = "kspn-tampa";
    switch (this.props.contents[this.props.virtual_keyboard_mode]) {
      case "UPCASE":
        innercontent = <FontAwesome name='arrow-up' />//<Icon type="up-circle-o" />
        break;
      case "DOWNCASE":
        innercontent = <FontAwesome name='arrow-down' />//<Icon type="down-circle-o" />
        break;
      case "DELETE":
        innercontent = <FontAwesome name='arrow-left' />//<Icon type="left" />
        break;
      case "Submit":
        spanClass = "kspn";
        classes += " primaryButton-tampa primaryButton-keyboardSearch"
        innercontent = this.props.contents[this.props.virtual_keyboard_mode];
        break;
      default:
        innercontent = this.props.contents[this.props.virtual_keyboard_mode];
        break;
    }

    return (
      <div onMouseDown={(e) => this.handlePress(e)} style={this.props.mainstyle} className={classes}>
        <span className={spanClass}>
          {innercontent}
          {this.props.contents[this.props.virtual_keyboard_mode] === "Submit" ? <div style={{ display: "inline-block" }}>&nbsp;&nbsp;<FontAwesome name='arrow-right' /></div> : null}
        </span>
      </div>
    )

  }
}

export default KeyboardKey;


// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/KeyboardKeyTampa.jsx